import(/* webpackMode: "eager" */ "/opt/build/repo/app/integrations/page.tsx");
